
import { Vue } from "vue-class-component";

export default class PickupTotalRequest extends Vue {}
